// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__RzfQR","content":"Footer_content__WE37V","links":"Footer_links__tiyTK","copyright":"Footer_copyright__bDpaX"};